module.exports = __webpack_public_path__ + "static/media/Raggruppa_70.377b8122.svg";